import { useState } from "react";
import { Link } from "react-router-dom";
import StudentHeader from "../components/StudentHeader";
import { cases } from "../data/studentData";

const BEST_KEY = "mushtariy_cases_best";
const maxScore = cases.length * 2;

const ranks = [
    { min: 0, title: "Boshlovchi tarbiyachi", text: "Izohlarni diqqat bilan o'qing va metodlar bo'limiga qayting." },
    { min: 50, title: "Izlanuvchan tarbiyachi", text: "Yaxshi natija! Ba'zi vaziyatlarda yanada asosli yechim mavjud." },
    { min: 80, title: "Mohir tarbiyachi", text: "A'lo! Siz pedagogik vaziyatlarda metodik jihatdan to'g'ri qaror qabul qila olasiz." },
];

const readBest = () => {
    try {
        return Number(localStorage.getItem(BEST_KEY)) || 0;
    } catch {
        return 0;
    }
};

function Cases() {
    const [index, setIndex] = useState(0);
    const [choices, setChoices] = useState({});
    const [finished, setFinished] = useState(false);
    const [best, setBest] = useState(readBest);

    const current = cases[index];
    const chosen = choices[index];
    const score = Object.entries(choices).reduce((acc, [i, oi]) => acc + cases[i].options[oi].score, 0);
    const percent = Math.round((score / maxScore) * 100);
    const rank = [...ranks].reverse().find((r) => percent >= r.min);

    const next = () => {
        if (index < cases.length - 1) {
            setIndex(index + 1);
            return;
        }
        if (percent > best) {
            setBest(percent);
            try {
                localStorage.setItem(BEST_KEY, String(percent));
            } catch {
                // e'tiborsiz
            }
        }
        setFinished(true);
        window.scrollTo(0, 0);
    };

    const restart = () => {
        setIndex(0);
        setChoices({});
        setFinished(false);
    };

    if (finished) {
        return (
            <>
                <StudentHeader title="Pedagogik keyslar natijasi" crumb="Keyslar" />
                <section className="pricing-one section-space-bottom">
                    <div className="container">
                        <div className="pricing-one__main-tab-box tabs-box">
                            <div className="pricing-one__inner px-3 px-lg-5 text-center" style={{ padding: "50px 20px" }}>
                                <h1 style={{ fontSize: "60px", color: "#ffb606", margin: 0 }}>{score} / {maxScore}</h1>
                                <h3 style={{ marginTop: 10 }}>{rank.title}</h3>
                                <p style={{ color: "#666" }}>{rank.text}</p>
                                <p style={{ fontSize: 14, color: "#999" }}>Eng yaxshi natijangiz: {Math.max(best, percent)}%</p>
                                <div className="text-start mx-auto mt-4" style={{ maxWidth: 700 }}>
                                    {cases.map((c, i) => {
                                        const o = c.options[choices[i]];
                                        return (
                                            <div key={c.id} className="d-flex justify-content-between" style={{ padding: "10px 0", borderBottom: "1px solid #eee", gap: 10 }}>
                                                <span>{i + 1}. {c.title}</span>
                                                <span style={{ color: o.score === 2 ? "#10b981" : o.score === 1 ? "#f59e0b" : "#ef4444", fontWeight: 600 }}>
                                                    {o.score} ball
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="d-flex justify-content-center" style={{ gap: 15, marginTop: 30, flexWrap: "wrap" }}>
                                    <button onClick={restart} className="eduhive-btn" style={{ border: "none" }}>
                                        <span>Qaytadan yechish</span>
                                    </button>
                                    <Link to="/reflection" className="eduhive-btn" style={{ background: "#666" }}>
                                        <span>Kundalikka xulosa yozish</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }

    return (
        <>
            <StudentHeader title="Pedagogik keyslar trenajyori" crumb="Keyslar" />
            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__inner px-3 px-lg-5" style={{ paddingTop: 40, paddingBottom: 40 }}>
                            <div className="d-flex justify-content-between mb-2" style={{ fontSize: 14, color: "#666" }}>
                                <span>Vaziyat {index + 1} / {cases.length}</span>
                                <span>Ball: {score}</span>
                            </div>
                            <div className="d-flex mb-4" style={{ gap: 6 }}>
                                {cases.map((c, i) => (
                                    <div key={c.id} style={{
                                        flex: 1, height: 6, borderRadius: 4,
                                        background: i < index || (i === index && chosen !== undefined) ? "#ffb606" : "#eee"
                                    }} />
                                ))}
                            </div>

                            <span style={{ background: "#f3f4f6", padding: "4px 12px", borderRadius: 20, fontSize: 13 }}>{current.age}</span>
                            <h3 style={{ margin: "14px 0" }}>{current.title}</h3>
                            <div style={{ background: "#fafafa", borderLeft: "4px solid #ffb606", borderRadius: 12, padding: 20, marginBottom: 20, fontSize: 17 }}>
                                {current.situation}
                            </div>
                            <h5 className="mb-3">Tarbiyachi sifatida qanday yo'l tutasiz?</h5>

                            {current.options.map((o, oi) => {
                                const isChosen = chosen === oi;
                                const reveal = chosen !== undefined;
                                const color = o.score === 2 ? "#10b981" : o.score === 1 ? "#f59e0b" : "#ef4444";
                                return (
                                    <div key={oi} style={{ marginBottom: 10 }}>
                                        <button
                                            onClick={() => !reveal && setChoices({ ...choices, [index]: oi })}
                                            disabled={reveal}
                                            style={{
                                                display: "block", width: "100%", textAlign: "left", padding: "12px 16px", borderRadius: 8,
                                                cursor: reveal ? "default" : "pointer",
                                                border: `1px solid ${reveal && (isChosen || o.score === 2) ? color : "#e5e5e5"}`,
                                                background: isChosen ? color : "#fff",
                                                color: isChosen ? "#fff" : "#333",
                                                opacity: reveal && !isChosen && o.score !== 2 ? 0.6 : 1,
                                            }}
                                        >
                                            {o.text}
                                        </button>
                                        {reveal && (isChosen || o.score === 2) && (
                                            <p style={{ margin: "6px 4px 0", fontSize: 14, color }}>
                                                {isChosen ? "Sizning tanlovingiz: " : "Eng yaxshi yechim: "}{o.feedback}
                                            </p>
                                        )}
                                    </div>
                                );
                            })}

                            {chosen !== undefined && (
                                <div className="text-center mt-4">
                                    <button onClick={next} className="eduhive-btn" style={{ border: "none" }}>
                                        <span>{index < cases.length - 1 ? "Keyingi vaziyat" : "Natijani ko'rish"}</span>
                                        <span className="eduhive-btn__icon">
                                            <span className="eduhive-btn__icon__inner"><i className="icon-right-arrow"></i></span>
                                        </span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Cases;
